import { fillInTheBlanksBaseExtensionConfig, tipTapFillInTheBlanksBaseExtensions } from '@lessonup/pins-shared';
import { cx } from '@lessonup/ui-components';
import { JSONContent, NodeViewRendererProps, Node as TiptapNode } from '@tiptap/core';
import { EditorContent, NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer, useEditor } from '@tiptap/react';
import React, { useEffect, useMemo } from 'react';
import { blankNodeCss, previewCss } from './FillInTheBlanksAreaPinComponent.utils';

interface TiptapViewerFillInTheBlanksProps {
  content: JSONContent;
  tipTapNode?: TiptapNode;
}

export const FillInTheBlanksTiptapViewer: React.FC<TiptapViewerFillInTheBlanksProps> = ({ content, tipTapNode }) => {
  const contentJson = useMemo(() => {
    if (typeof content === 'string') {
      return JSON.parse(content);
    }
    return content;
  }, [content]);

  const extensions = useMemo(() => {
    if (tipTapNode) {
      return [...tipTapFillInTheBlanksBaseExtensions, tipTapNode];
    }
    return fillInTheBlanksViewerExtensions;
  }, [tipTapNode]);

  // we cant use renderHTML here because we need to use the tiptap
  // editor to use a react component to render the blanks
  const editor = useEditor(
    {
      content: contentJson,
      immediatelyRender: false,
      editable: false,
      extensions,
    },
    []
  );

  // Update editor content when contentJson changes
  useEffect(() => {
    if (editor && contentJson) {
      editor.commands.setContent(contentJson);
    }
  }, [editor, contentJson]);

  return <EditorContent editor={editor} />;
};

export const FillInTheBlanksWordNode: React.FC<NodeViewRendererProps> = ({ node }) => {
  const isEmpty = !node.textContent && node.childCount === 0;

  return (
    <NodeViewWrapper className={cx(blankNodeCss, isEmpty && previewCss)}>
      {isEmpty ? <span>&nbsp;</span> : <NodeViewContent />}
    </NodeViewWrapper>
  );
};

export const fillIntheBlanksExtension = TiptapNode.create({
  ...fillInTheBlanksBaseExtensionConfig,
  addNodeView: () => {
    return ReactNodeViewRenderer(FillInTheBlanksWordNode);
  },
});

export const fillInTheBlanksViewerExtensions = [...tipTapFillInTheBlanksBaseExtensions, fillIntheBlanksExtension];
